"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "teamsDarkTheme", {
    enumerable: true,
    get: function() {
        return teamsDarkTheme;
    }
});
const _createTeamsDarkTheme = require("../../utils/createTeamsDarkTheme.js");
const _brandColors = require("../../global/brandColors.js");
const _teamsFontFamilies = require("../../alias/teamsFontFamilies.js");
const teamsDarkTheme = {
    ...(0, _createTeamsDarkTheme.createTeamsDarkTheme)(_brandColors.brandTeams),
    ..._teamsFontFamilies.fontFamilies
};
